module.exports = __webpack_public_path__ + "img/mm.bd85d8d6.svg";